export function normalizeToArray(value: undefined | string | string[]) {
  return Array.isArray(value) ? value : value === undefined ? [] : [value];
}
